"use client";
import { motion } from "framer-motion";
import { BgLayer } from "./bg/BgPrimitives";

const checklistItems = [
  "How your money habits shape your choices",
  "How to plan, budget, and stay in control",
  "How borrowing, credit, and interest really work",
  "How to understand the taxes and costs built into everyday spending",
  "How to think about saving, investing, and growing your money",
  "How money connects to freelancing, work, entrepreneurship, and digital finance",
];

export default function ProgramOverview() {
  return (
    <section id="program" className="bg-muted py-24 md:py-32 relative overflow-hidden section-grain">
      <BgLayer />
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-foreground">
              What this program is
            </h2>
            <p className="text-foreground/70 leading-relaxed mb-4">
              This is a guided financial literacy learning experience designed for youth.
            </p>
            <p className="text-foreground/70 leading-relaxed mb-4">
              It combines short self-paced online sessions, practical activities, quizzes, and
              support tools to help you build real financial understanding step by step.
            </p>
            <p className="text-foreground/70 leading-relaxed">
              You will not just learn concepts. You will practice how to apply them to situations
              that matter in everyday life and in your future.
            </p>
          </motion.div>

          {/* Right column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            <h3 className="text-xl font-bold mb-6 text-foreground">What you&apos;ll explore</h3>
            <ul className="space-y-4">
              {checklistItems.map((item, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: -12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                  className="flex items-start gap-3"
                >
                  <motion.span
                    initial={{ scale: 0, rotate: -45 }}
                    whileInView={{ scale: 1, rotate: 0 }}
                    viewport={{ once: true }}
                    transition={{ type: "spring", stiffness: 350, damping: 18, delay: i * 0.07 + 0.1 }}
                  >
                    <img src="/icons/JA Dark_CHECKMARK.png" alt="" width={26} height={26} className="shrink-0 mt-0.5" />
                  </motion.span>
                  <span className="text-foreground leading-relaxed">{item}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
